import { create } from "zustand";
import axios from "axios";
import Cookies from "js-cookie";

const productRatingStore = create((set) => ({
  myReview: null,
  allReview: null,
  isLoadingUser: true,
  isLoadingAll: true,

  createProductRating: async ({ productID, rating, review }) => {
    try {
      set({ isLoadingUser: true });
      const res = await axios.post("/site/create-product-rating", {
        productID,
        rating,
        review,
      });

      const { myReview, allReview } = productRatingStore.getState();
      const myData = myReview ? myReview : [];
      const allData = allReview ? allReview : [];
      myData.push(res.data.productRating);
      allData.push(res.data.productRating);

      set({ myReview: myData, allReview: allData });
      set({ isLoadingUser: false });
    } catch (error) {
      console.log(error);
      set({ isLoadingUser: false });
    }
  },

  fetchAllUserProductRating: async () => {
    try {
      const res = await axios.get("/site/fetch-all-user-product-rating");

      if (res.data.productRating.length) {
        set({ myReview: res.data.productRating });
      }
      set({ isLoadingUser: false });
    } catch (error) {
      console.log(error);
      set({ isLoadingUser: false });
    }
  },

  fetchAllProductRating: async () => {
    try {
      const res = await axios.get("/site/fetch-all-product-rating");

      if (res.data.productRating.length) {
        set({ allReview: res.data.productRating });
      }
      set({ isLoadingAll: false });
    } catch (error) {
      console.log(error);
      set({ isLoadingAll: false });
    }
  },
}));

export default productRatingStore;
